import React, { useState } from "react";
import axios from "axios";
import { API_IP } from "../env";
import "./LoginScreen.css";

function LoginScreen({ setIsLogin, theme, toggleTheme }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setErrorMessage(null);

    try {
      const { data } = await axios.post(`${API_IP}/api/login`, {
        username,
        password,
      });

      if (data.isAdmin) {
        localStorage.setItem("@uphealth_login_token", data.token);
        setIsLogin(true);
      } else {
        setErrorMessage("You do not have permission to access this page.");
      }
    } catch (err) {
      setErrorMessage("Invalid username or password. Please try again.");
      console.log(err);
    }
    setLoading(false);
  };

  return (
    <div className={`login-root login-root--${theme}`}>
      {/* Theme toggle */}
      <button className="login-theme-toggle" onClick={toggleTheme} title="Toggle theme">
        <i className={`bi ${theme === "dark" ? "bi-sun" : "bi-moon-stars"}`} />
      </button>

      {/* Ambient background */}
      <div className="login-bg">
        <div className="login-bg__orb login-bg__orb--1" />
        <div className="login-bg__orb login-bg__orb--2" />
        <div className="login-bg__grid" />
      </div>

      {/* Left hero panel */}
      <div className="login-hero">
        <div className="login-hero__brand">
          <img
            src={require("../assets/icon-uphealth.png")}
            alt="UpHealth"
            className="login-hero__logo"
          />
          <h1 className="login-hero__title">
            iCare<span>Solutions</span>
          </h1>
          <p className="login-hero__subtitle">
            Administration Control Center — manage bookings, providers, and users from a single unified dashboard.
          </p>
        </div>

        <div className="login-hero__features">
          <div className="login-feature">
            <div className="login-feature__icon login-feature__icon--teal">
              <i className="bi bi-calendar-check" />
            </div>
            <div className="login-feature__text">
              <strong>Booking Management</strong>
              <small>Track and assign care bookings in real time</small>
            </div>
          </div>
          <div className="login-feature">
            <div className="login-feature__icon login-feature__icon--violet">
              <i className="bi bi-person-badge" />
            </div>
            <div className="login-feature__text">
              <strong>Provider Network</strong>
              <small>Verify, onboard and manage care providers</small>
            </div>
          </div>
          <div className="login-feature">
            <div className="login-feature__icon login-feature__icon--blue">
              <i className="bi bi-people" />
            </div>
            <div className="login-feature__text">
              <strong>User Analytics</strong>
              <small>Monitor patient accounts and health activity</small>
            </div>
          </div>
        </div>
      </div>

      {/* Right form panel */}
      <div className="login-panel">
        <div className="login-form-card">
          <div className="login-form-header">
            <h2>Welcome back</h2>
            <p>Sign in to your administrator account</p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="login-field">
              <label className="login-label" htmlFor="login-username">
                Username or Email
              </label>
              <div className="login-input-wrap">
                <i className="bi bi-person" />
                <input
                  id="login-username"
                  className="login-input"
                  type="text"
                  placeholder="Enter username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  disabled={loading}
                  autoComplete="username"
                />
              </div>
            </div>

            <div className="login-field">
              <label className="login-label" htmlFor="login-password">
                Password
              </label>
              <div className="login-input-wrap">
                <i className="bi bi-lock" />
                <input
                  id="login-password"
                  className="login-input"
                  type="password"
                  placeholder="Enter password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  disabled={loading}
                  autoComplete="current-password"
                />
              </div>
            </div>

            {errorMessage && (
              <div className="login-error">
                <i className="bi bi-exclamation-circle-fill" />
                {errorMessage}
              </div>
            )}

            <button type="submit" className="login-btn" disabled={loading}>
              {loading ? (
                <>
                  <span className="login-spinner" />
                  Signing in…
                </>
              ) : (
                <>
                  <i className="bi bi-box-arrow-in-right" />
                  Sign In
                </>
              )}
            </button>
          </form>

          <div className="login-form-footer">
            <i className="bi bi-shield-lock-fill" />
            Secure admin access · iCareSolutions Platform
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginScreen;
